<template>
  <el-dialog
    :model-value="draftEmailVisible"
    @update:model-value="$emit('update:draftEmailVisible', $event)"
    title="Draft Email"
    width="600px"
    :close-on-click-modal="false"
    :z-index="1000002">
    <div v-if="draftEmailLoading" class="draft-email-loading">
      <div class="tool-spinner"></div>
      <span>Generating email draft...</span>
    </div>
    <div v-if="draftEmailContent" class="draft-email-content">
      <div v-html="renderMarkdown(draftEmailContent)"></div>
    </div>
    <template #footer>
      <el-button @click="$emit('update:draftEmailVisible', false)">
        Close
      </el-button>
      <el-button
        type="primary"
        @click="$emit('copyToClipboard', draftEmailContent)"
        :disabled="!draftEmailContent">
        Copy to Clipboard
      </el-button>
    </template>
  </el-dialog>

  <el-dialog
    :model-value="createTaskVisible"
    @update:model-value="$emit('update:createTaskVisible', $event)"
    :title="`Create HubSpot Task for ${taskFormCustomerName}`"
    width="500px"
    :z-index="1000002">
    <el-form label-position="top">
      <el-form-item label="Title">
        <el-input
          :model-value="taskForm.title"
          @input="$emit('update:taskForm', { ...taskForm, title: $event })" />
      </el-form-item>
      <el-form-item label="Description">
        <el-input
          :model-value="taskForm.body"
          @input="$emit('update:taskForm', { ...taskForm, body: $event })"
          type="textarea"
          :rows="3" />
      </el-form-item>
      <el-form-item label="Due Date">
        <el-date-picker
          :model-value="taskForm.due_date"
          @update:model-value="
            $emit('update:taskForm', { ...taskForm, due_date: $event })
          "
          type="date"
          style="width: 100%" />
      </el-form-item>
      <el-form-item label="Priority">
        <el-select
          :model-value="taskForm.priority"
          @update:model-value="
            $emit('update:taskForm', { ...taskForm, priority: $event })
          "
          style="width: 100%">
          <el-option label="Low" value="LOW" />
          <el-option label="Medium" value="MEDIUM" />
          <el-option label="High" value="HIGH" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="$emit('update:createTaskVisible', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        @click="$emit('submitCreateTask')"
        :loading="actionLoading">
        Create Task
      </el-button>
    </template>
  </el-dialog>

  <el-dialog
    :model-value="createDealVisible"
    @update:model-value="$emit('update:createDealVisible', $event)"
    :title="`Create HubSpot Deal for ${dealFormCustomerName}`"
    width="500px"
    :z-index="1000002">
    <el-form label-position="top">
      <el-form-item label="Deal Name">
        <el-input
          :model-value="dealForm.name"
          @input="$emit('update:dealForm', { ...dealForm, name: $event })" />
      </el-form-item>
      <el-form-item label="Amount">
        <el-input
          :model-value="dealForm.amount"
          @input="$emit('update:dealForm', { ...dealForm, amount: $event })"
          type="number" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="$emit('update:createDealVisible', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        @click="$emit('submitCreateDeal')"
        :loading="actionLoading">
        Create Deal
      </el-button>
    </template>
  </el-dialog>

  <el-dialog
    :model-value="saveNoteVisible"
    @update:model-value="$emit('update:saveNoteVisible', $event)"
    title="Save Note to HubSpot"
    width="500px"
    :z-index="1000002">
    <el-form label-position="top">
      <el-form-item label="Note Content">
        <el-input
          :model-value="noteForm.content"
          @input="$emit('update:noteForm', { ...noteForm, content: $event })"
          type="textarea"
          :rows="6" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="$emit('update:saveNoteVisible', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        @click="$emit('submitSaveNote')"
        :loading="actionLoading">
        Save Note
      </el-button>
    </template>
  </el-dialog>

  <el-dialog
    :model-value="actionSuccessVisible"
    @update:model-value="$emit('update:actionSuccessVisible', $event)"
    title="Success"
    width="400px"
    :z-index="1000002">
    <div style="text-align: center; padding: 20px 0">
      <el-icon :size="48" style="color: #67c23a; margin-bottom: 12px">
        <CircleCheckFilled />
      </el-icon>
      <p>Action completed successfully!</p>
      <a
        v-if="actionSuccessUrl"
        :href="actionSuccessUrl"
        target="_blank"
        rel="noopener">
        View in HubSpot &rarr;
      </a>
    </div>
    <template #footer>
      <el-button
        type="primary"
        @click="$emit('update:actionSuccessVisible', false)">
        Close
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { CircleCheckFilled } from "@element-plus/icons-vue";

export default {
  components: { CircleCheckFilled },
  props: {
    draftEmailVisible: Boolean,
    draftEmailLoading: Boolean,
    draftEmailContent: String,
    createTaskVisible: Boolean,
    taskForm: Object,
    taskFormCustomerName: { type: String, default: "" },
    createDealVisible: Boolean,
    dealForm: Object,
    dealFormCustomerName: { type: String, default: "" },
    saveNoteVisible: Boolean,
    noteForm: Object,
    actionLoading: Boolean,
    actionSuccessVisible: Boolean,
    actionSuccessUrl: String,
    renderMarkdown: Function,
  },
  emits: [
    "update:draftEmailVisible",
    "update:createTaskVisible",
    "update:createDealVisible",
    "update:saveNoteVisible",
    "update:actionSuccessVisible",
    "update:taskForm",
    "update:dealForm",
    "update:noteForm",
    "copyToClipboard",
    "submitCreateTask",
    "submitCreateDeal",
    "submitSaveNote",
  ],
};
</script>
